// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, is, maybe, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

const nullableString = anyOf(maybe(string), nullOrUndefined);

const isBdsDestinationSchemaColumnRef = objectOf({
  name: string,
  is_primary_key: maybe(boolean),
  source_type: nullableString,
  destination_type: nullableString,
});

const isBdsDestinationSchemaStatus = anyOf(
  is("dataset_not_created"),
  is("table_not_created"),
  is("compared"),
  is("skipped"),
  is("unavailable")
);

export const isBdsDestinationSchemaCheck = objectOf({
  status: isBdsDestinationSchemaStatus,
  big_query_project: maybe(string),
  big_query_dataset: maybe(string),
  big_query_table_name: maybe(string),
  warnings: maybe(arrayOf(string)),
  errors: maybe(arrayOf(string)),
  columns_missing_in_destination: maybe(arrayOf(isBdsDestinationSchemaColumnRef)),
  columns_missing_in_source: maybe(arrayOf(isBdsDestinationSchemaColumnRef)),
});

export const isPostIntegrationsDirectCdiImportSyncsTestConnectionResult = objectOf({
  data_preview: arrayOf(
    objectOf({
      PAYLOAD: maybe(string),
      EXTERNAL_ID: maybe(string),
      ALIAS_NAME: maybe(string),
      ALIAS_LABEL: maybe(string),
      BRAZE_ID: maybe(string),
    })
  ),
  error: maybe(string),
  status: string,
  destination_schema: maybe(isBdsDestinationSchemaCheck),
});
